import WandhUI from '@/components/labs/wandh/wandh-ui.vue';
export default defineComponent({
  components: {
    'wandh-ui': WandhUI
  },
  layout: 'labs'
});